<div class="login-text" style="margin-bottom: 8px">{{ title }}</div>

<div *ngIf="Status == 0">
  <span>Load data...</span>
</div>

<form *ngIf="Status != 0" #form="ngForm" novalidate>
  <div class="ui-g-12" [hidden]="Status != 2">
    <p>{{ completedMessage }} Please <a href="/">Click here to log in</a>.</p>
  </div>
  <div class="ui-g-12" [hidden]="Status != 3">
    <p>Failed to load data. Try to reload the page.</p>
  </div>

  <div [hidden]="Status == 2 || Status == 3">
    <p *ngIf="isNewAccount">Welcome. Choose a password to finish setting up your account.</p>

    <div class="grid mt-2">
      <div class="col">
        <div class="ui-inputgroup">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!passwordForm.controls.password"
            style="flex-grow: 1"
          >
            <input
              id="password"
              type="password"
              autocomplete="off"
              [formControl]="passwordForm.controls.password"
              required
              strongPassword="2"
            />
            <label for="password">Password</label>
          </div>
        </div>
      </div>
    </div>
    <password-feedback
      [passwordControl]="passwordControl"
      [confirmPasswordControl]="confirmPasswordConrol"
    ></password-feedback>

    <div class="grid">
      <div class="col">
        <div class="ui-inputgroup">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!passwordForm.controls.confirmPassword"
            style="flex-grow: 1"
          >
            <input
              id="confirmPassword"
              type="password"
              autocomplete="off"
              [formControl]="passwordForm.controls.confirmPassword"
              required
            />
            <label>Confirm Password</label>
          </div>
        </div>
      </div>
    </div>

    <password-match [passwordForm]="passwordForm"></password-match>

    <div class="ui-g-12">
      <div>
        <button
          pButton
          [disabled]="saveDisabled"
          type="button"
          id="resetPasswordSave"
          class="secondary"
          style="width: 100%"
          (click)="Save()"
          [label]="saveLabel"
        ></button>
      </div>
      <div>
        <button type="button" class="back-to-login-btn" (click)="router.navigate(['/account'])">
          <i class="fa fa-arrow-left" style="margin-right: 5px" aria-hidden="true"></i>Back to Login
        </button>
      </div>
    </div>
  </div>
</form>

<p-toast key="contactEngineiusHtmlBody">
  <ng-template let-message pTemplate="message">
    <h4 innerHtml="{{ message.summary }}"></h4>
    <p innerHtml="{{ message.detail }}"></p>
    <a class="recover-link-button" (click)="sendRequestPasswordLink()">{{ requestNewLinkLabel }}</a>
  </ng-template></p-toast
>
